import { Component, OnInit, Inject, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { CommentService } from '../../services/comment.service';
import { ContactService } from '../../services/contact.service';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { ActionType, Comment, Contact, CustomerAction, CustomerActionForm, Employee, SearchOpportunity } from '../../models/models';

@Component({
    selector: 'add-customer-action',
    templateUrl: './add-customer-action.component.html',
    standalone: false
})
export class AddCustomerAction implements OnInit, OnChanges {
    @Input() customerActionId: number = 0;
    @Input() customerId: number = 0;
    @Input() customerAction: CustomerAction = {} as CustomerAction;
    @Input() opportunityId: number = 0;

    @Output() actionSaved: EventEmitter<CustomerAction> = new EventEmitter<CustomerAction>();

    private selectedCustomerId: number = 0;
    private selectedCustomerActionId: number = 0;
    private selectedCustomerAction: CustomerAction = {} as CustomerAction;
    private fetchedOpportunities: boolean = false;

    public allActionTypes: ActionType[] = [];
    public actionTypes: ActionType[] = [];
    public contacts: Contact[] = [];
    public employees: Employee[] = [];
    private loggedInEmployee: Employee = {} as Employee;
    private comment: Comment = {} as Comment;
    public opportunities: SearchOpportunity[] = [];
    public parentCustomerAction: CustomerAction = {} as CustomerAction;
    public actionForm: UntypedFormGroup = new UntypedFormGroup({});
    public savedCustomerAction: CustomerAction = {} as CustomerAction;
    public saveMessage: string = '';
    public submitted: boolean = false;
    public saving: boolean = false;
    public followUpIsVisible: boolean = true;
    public showAssignToMessage: boolean = false;

    public addNewContact: boolean = false;
    public contactName: string = '';
    public contactPhone: string = '';
    public contactPhoneExt: string = '';
    public contactEmail: string = '';
    public contactTitle: string = '';
    public contactSaveMessage: string = '';
    public phoneMask: string = "(999) 000-0000";

    constructor(private route: ActivatedRoute, private titleService: Title, private router: Router,
        private commentService: CommentService, private contactService: ContactService, private crmService: CRMService,
        private employeeService: EmployeeService,
        public dialog: MatDialog, private formBuilder: UntypedFormBuilder) { }

    ngOnInit() {
        this.buildForm();
        this.getActionTypes();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.customerId == null || changes.customerId.currentValue == null || changes.customerId.currentValue.toString() == '') return;

        this.selectedCustomerId = parseInt(changes.customerId.currentValue);
        if (changes.customerActionId != null && changes.customerActionId.currentValue != null) this.selectedCustomerActionId = parseInt(changes.customerActionId.currentValue);
        this.getContacts();
        this.getOpportunities();
        this.getCustomerAction();
    }

    private buildForm() {
        this.actionForm = this.formBuilder.group({
            ownerNameCtrl: [{ value: '', disabled: true }, Validators.required],
            actionTypeCtrl: ['', Validators.required],
            eventDateCtrl: [new Date(), Validators.required],
            contactCtrl: [-1],
            opportunityCtrl: [-1],
            detailsCtrl: ['', Validators.required],
            followUpCtrl: [false],
            followUpDateCtrl: [new Date(new Date().setDate(new Date().getDate() + 7))],
            assignToCtrl: [parseInt(localStorage.getItem('EmployeeId')!)]
        });
    }

    private getActionTypes() {
        this.crmService.getActionTypes().subscribe(result => {
            this.allActionTypes = result;
            this.actionTypes = result.filter(a => a.actionTypeId > 0 && a.retiredInd != true);
        });
    }

    private getEmployees() {
        this.employeeService.getLoggedInEmployee().subscribe(result => {
            if (this.selectedCustomerActionId < 1) {
                this.actionForm.controls['ownerNameCtrl'].setValue(result.fullName);
                this.loggedInEmployee = result;
            }
        });

        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employees = result;
        });
    }

    private setCustomerActionEmployee() {
        if (this.selectedCustomerAction.createEmployeeId == this.loggedInEmployee.employeeId) {
            this.actionForm.controls['ownerNameCtrl'].setValue(this.loggedInEmployee.fullName);
        }
        else {
            var emp = this.employees.find(t => t.employeeId == this.selectedCustomerAction.createEmployeeId);
            if (emp != null) {
                this.actionForm.controls['ownerNameCtrl'].setValue(emp.fullName);
            }
        }
    }

    private getContacts() {
        this.contactService.getContactsByTableIdType(this.selectedCustomerId, 'customer').subscribe(result => {
            this.contacts = result;

            if (this.selectedCustomerActionId < 1) {
                var defaultContact = this.contacts.find(c => c.defaultContactInd == true);

                if (defaultContact != null) this.actionForm.controls['contactCtrl'].setValue(defaultContact.contactID);
            }
        });
    }

    private getOpportunities() {
        if (this.selectedCustomerId < 1 || this.opportunities.length > 0 || this.fetchedOpportunities) return;

        this.fetchedOpportunities = true;

        this.crmService.getSearchOpportunityByCustomerID(this.selectedCustomerId).subscribe(result => {
            this.opportunities = result.resultCollection;

            if (this.opportunityId > 0) {
                this.actionForm.controls['opportunityCtrl'].setValue(this.opportunityId);
                this.actionForm.controls['opportunityCtrl'].disable();
            }
        });
    }

    private getComment() {
        this.commentService.getCommentById(this.selectedCustomerAction.commentID).subscribe(result => {
            this.comment = result;
            if (this.comment != null) {
                this.actionForm.controls['detailsCtrl'].setValue(this.comment.commentText);
            }
        });
    }

    private getCustomerAction() {
        if (this.selectedCustomerActionId < 1) return;

        this.crmService.getCustomerActionByid(this.selectedCustomerActionId).subscribe(result => {
            this.selectedCustomerAction = result;
            this.getEmployees();
            this.getComment();
            this.setFormValues();

            if (this.selectedCustomerAction.parentCustomerActionID > 0 && this.selectedCustomerAction.actionTypeID < 0) {
                this.actionTypes = this.allActionTypes;
                this.followUpIsVisible = false;

                this.crmService.getCustomerActionByid(this.selectedCustomerAction.parentCustomerActionID).subscribe(parentResult => {
                    if (parentResult == null) return;

                    this.parentCustomerAction = parentResult;
                    this.actionForm.controls['detailsCtrl'].setValue(parentResult.notes);
                });
            }
        });
    }

    private setFormValues() {
        if (this.selectedCustomerAction == null ||
            this.selectedCustomerAction.customerActionID == null ||
            this.selectedCustomerAction.customerActionID < 1) {
            return;
        }

        this.setCustomerActionEmployee();
        this.actionForm.controls['actionTypeCtrl'].setValue(this.selectedCustomerAction.actionTypeID);
        this.actionForm.controls['contactCtrl'].setValue(this.selectedCustomerAction.contactID);
        this.actionForm.controls['followUpCtrl'].setValue(this.selectedCustomerAction.followUpInd);
        if (this.selectedCustomerAction.followUpEmployeeID != null) {
            this.actionForm.controls['assignToCtrl'].setValue(this.selectedCustomerAction.followUpEmployeeID);
        }
        if (this.opportunityId == null || this.opportunityId < 1) this.actionForm.controls['opportunityCtrl'].setValue(this.selectedCustomerAction.opportunityId);

        if (this.selectedCustomerAction.actionTypeID > 0) {
            this.actionForm.controls['eventDateCtrl'].setValue(new Date(this.selectedCustomerAction.eventDate));
            this.actionForm.controls['followUpDateCtrl'].setValue(new Date(this.selectedCustomerAction.followUpDate));
        } else {
            if (new Date(this.selectedCustomerAction.eventDate) < new Date()) {
                this.actionForm.controls['eventDateCtrl'].setValue(new Date());
            } else {
                this.actionForm.controls['eventDateCtrl'].setValue(new Date(this.selectedCustomerAction.eventDate));
            }
        }
    }

    public saveAction() {
        this.saving = true;
        this.submitted = true;
        this.showAssignToMessage = false;

        var actionForm = {
            customerActionID: this.selectedCustomerActionId,
            actionTypeID: this.actionForm.controls['actionTypeCtrl'].value,
            customerID: this.selectedCustomerId,
            contactID: this.actionForm.controls['contactCtrl'].value,
            details: this.actionForm.controls['detailsCtrl'].value,
            eventDate: this.actionForm.controls['eventDateCtrl'].value,
            followUp: this.actionForm.controls['followUpCtrl'].value,
            followUpDate: this.actionForm.controls['followUpDateCtrl'].value,
            followUpEmployeeID: this.actionForm.controls['assignToCtrl'].value,
            createdByEmployeeId: parseInt(localStorage.getItem('EmployeeId')!),
            commentID: this.selectedCustomerActionId != null && this.selectedCustomerActionId > 0 ? this.selectedCustomerAction.commentID : 0,
            opportunityId: this.actionForm.controls['opportunityCtrl'].value
        } as CustomerActionForm;

        if (actionForm.actionTypeID.toString() == '' || actionForm.details.length < 1) {
            this.saving = false;
            return;
        }

        if (actionForm.followUp && actionForm.followUpEmployeeID == null) {
            this.saving = false;
            this.showAssignToMessage = true;
            return;
        }

        if (actionForm.contactID == null || actionForm.contactID.toString() == '') actionForm.contactID = 0;
        if (actionForm.followUpEmployeeID == null) actionForm.followUpEmployeeID = 0;
        if (actionForm.opportunityId == null) actionForm.opportunityId = 0;
        if (actionForm.actionTypeID < 1) actionForm.followUpDate = actionForm.eventDate;

        this.crmService.saveCustomerActionForm(actionForm).subscribe(result => {
            this.saving = false;
            this.savedCustomerAction = result;
            this.actionSaved.emit(this.savedCustomerAction);

            if (this.savedCustomerAction != null) {
                this.saveMessage = 'Created customer action';
            }
            else {
                this.saveMessage = 'Failed to save customer action';
            }
        });
    }

    public saveContact() {
        this.contactSaveMessage = '';
        this.saving = true;

        var newContact = {
            contactID: 0,
            contactType: 'Customer',
            tableID: this.selectedCustomerId,
            firstName: this.contactName.split(' ')[0],
            lastName: this.contactName.replace(this.contactName.split(' ')[0], ''),
            phone: this.contactPhone,
            phoneExt: this.contactPhoneExt,
            email: this.contactEmail,
            title: this.contactTitle
        } as Contact;

        this.contactService.saveContact(newContact).subscribe(result => {
            this.saving = false;

            if (result != null && result.contactID != null && result.contactID > 0) {
                this.getContacts();
                this.actionForm.controls['contactCtrl'].setValue(result.contactID);
                this.addNewContact = false;
            } else {
                this.contactSaveMessage = 'Failed to save contact';
            }
        });
    }

    public getContact(): Contact {
        var contactId = this.actionForm.controls['contactCtrl'].value;

        if (contactId == null || contactId.toString() == '' || parseInt(contactId.toString()) < 0) return {} as Contact;

        var contact = this.contacts.find(c => c.contactID == parseInt(contactId));

        if (contact == null) return {} as Contact;

        return contact;
    }

    public actionTypeChanged(actionTypeId: number) {
        if (this.selectedCustomerActionId < 1
            || this.selectedCustomerAction.actionTypeID == null
            || this.selectedCustomerAction.actionTypeID > 0
            || actionTypeId < 1) return;

        this.actionForm.controls['eventDateCtrl'].setValue(new Date());
        this.actionForm.controls['followUpDateCtrl'].setValue(new Date(new Date().setDate(new Date().getDate() + 7)));
        this.followUpIsVisible = true;
    }
}

@Component({
    selector: 'add-customer-action-dialog',
    templateUrl: './dialog.component.html',
    standalone: false
})
export class AddCustomerActionDialog {
    public savedCustomerAction: CustomerAction = {} as CustomerAction;

    constructor(public dialogRef: MatDialogRef<AddCustomerActionDialog>, @Inject(MAT_DIALOG_DATA) public data: any) { }

    customerActionSaved(customerAction: CustomerAction) {
        this.savedCustomerAction = customerAction;
        this.cancel();
    }

    cancel(): void {
        this.dialogRef.close({ customerAction: this.savedCustomerAction });
    }
}
